<template>
  <div class>
    <!-- 상단 고정 캠페인 배너 -->
    <div
      v-if="
        campaignData &&
        campaignData.dynamicLink &&
        campaignData.locationValue === null
      "
    >
      <a :href="campaignData.dynamicLink.shortLink" target="_blank">
        <img :src="campaignData.image" :alt="campaignData.dynamicLink.name" />
      </a>
    </div>

    <NoData v-if="isNoData" :type="myStatus"></NoData>

    <div class="pdt-16 pdl-8 pdr-8 pdb-20">
      <div class="d-flex two-column">
        <div
          v-for="(badgeList, index) in listData"
          :key="index"
          style="width: 50%"
          class="pdl-8 pdr-8"
        >
          <!-- 목록 캠페인 카드 -->
          <ListItem :badgeList="badgeList" :myStatus="myStatus"></ListItem>
        </div>
      </div>
      <infinite-loading
        @infinite="fetchData"
        :identifier="infiniteId"
        spinner="spiral"
      >
        <div slot="no-more" class="mgt-16"></div>
        <div slot="no-results" class="mgt-16"></div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import rewardApi from "@/api/rewardApi.js";
import campaignApi from "@/api/campaignApi.js";
import ListItem from "./ListItem.vue";
import NoData from "../common/NoDataBadgeList.vue";
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    ListItem,
    NoData,
    InfiniteLoading,
  },

  data() {
    return {
      status: "",
      isNoData: false,
      campaignData: null,
      listData: [],
      currentPage: 1,
      totalPages: 1,
      mine: "",
      myStatus: "",
      infiniteId: +new Date(),
    };
  },

  computed: {},

  watch: {
    $route(to, from) {
      this.initData();
      this.myStatus = this.$route.query.status;
    },
  },

  mounted() {
    // 기본 파라미터 설정(set default parameter)
    if (!this.$route.query.status) {
      this.$router.push({ query: { status: "BADGE" } });
      this.myStatus = this.$route.query.status;
    } else {
      this.myStatus = this.$route.query.status;
    }
  },

  methods: {
    initData() {
      this.listData = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1;
    },
    // 목록 데이터 로딩(get list data)
    fetchData($state) {
      let responseData = null;
      let params = this.setParams();
      console.log("params", params);
      if (this.totalPages >= this.currentPage) {
        rewardApi
          .rewardBadgeList(params)
          .then((response) => {
            responseData = response.data.data;
            //console.log('responseData=>',responseData);
            // this.mine = responseData.mine;

            this.listData = this.listData.concat(responseData.content);
            console.log("listData=>", this.listData);
            this.currentPage++;
            this.totalPages = responseData.totalPages;

            if (responseData.content.length) {
              $state.loaded();
            } else {
              $state.complete();
            }

            console.log("nodata", this.listData.length);
            if (this.listData.length > 0) {
              this.isNoData = false;
            } else {
              this.isNoData = true;
            }
          })
          .catch((err) => {
            $state.error();
          });
      } else {
        $state.complete();
      }

      // 캠페인 테이터 API 호출(get campaign data)
      let locationType =
        this.$route.query.status === "LEARNING"
          ? "LEARN_IN_PROGRESS_DEGREE"
          : "LEARN_COMPLETED_DEGREE";
      campaignApi
        .campaign({ locationType: locationType })
        .then((response) => {
          this.campaignData = response.data.data;
        })
        .catch((err) => {});
    },

    // 파라미터 설정(set parameter)
    setParams() {
      const params = {
        status: this.$route.query.status,
        // name: "",
        // category: "",
        page: this.currentPage,
        size: 10,
        sort: "id,desc",
      };
      return params;
    },

    // 학습진행률 노출 상태 설정(set/toggle learning status graph)
    initProgressStatus(id) {
      _.map(this.listData, (o) => {
        o.id === id && o.progressViewStatus === false
          ? (o.progressViewStatus = true)
          : (o.progressViewStatus = false);
      });
    },
  },
};
</script>

<style scoped>
.two-column {
  flex-wrap: wrap;
}
</style>